import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import {default as templateStore} from "@/store";

import {defineComponent} from 'vue'
import store from "@/store";

const __default__ = defineComponent({
    name: 'ToolTip',

    data(): {
        properties: {[property: string]: string}
        offset: number
    } {
        return {
            properties: {},
            offset: 30,
        }
    },

    computed: {
        style(): {[property: string]: string}
        {
            const properties: {[property: string]: string} = this.properties

            const x: number = store.state.cursor.x
            const y: number = store.state.cursor.y

            const width: number = window.innerWidth
            const height: number = window.innerHeight

            if (x <= width / 2 + 250) {
                properties.left = `${x + this.offset}px`
                properties.right = `auto`
            } else {
                properties.left = `auto`
                properties.right = `${width - x + this.offset}px`
            }

            if (y <= height / 2) {
                properties.bottom = `auto`
                properties.top = `${y + this.offset}px`
            } else {
                properties.bottom = `${height - y + this.offset}px`
                properties.top = `auto`
            }

            return properties
        }
    }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(templateStore).state.passBonus)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "content",
        style: _normalizeStyle(_ctx.style),
        innerHTML: _unref(templateStore).state.passBonus.description
      }, null, 12, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})